export default "__VITE_ASSET__DeTvs6Am__"